import React, {useState} from 'react';
import {styled} from '@mui/material/styles';
import PropTypes from 'prop-types';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import Dialog from '@mui/material/Dialog';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

import {faCopy} from '@fortawesome/pro-light-svg-icons';

const PREFIX = 'ShareDialog';

const classes = {
  textField: `${PREFIX}-textField`,
  buttonCopy: `${PREFIX}-buttonCopy`,
  buttonClose: `${PREFIX}-buttonClose`,
  content: `${PREFIX}-content`,
};

const StyledDialog = styled(Dialog)({
  [`& .${classes.textField}`]: {
    width: 250,
  },
  [`& .${classes.buttonCopy}`]: {
    color: '#FFF',
    backgroundColor: getComputedStyle(document.documentElement).getPropertyValue('--primary-500'),
    marginLeft: 20,
    '&:hover': {
      backgroundColor: '#3b3d51',
    },
  },
  [`& .${classes.buttonClose}`]: {
    color: '#525A63',
  },
  [`& .${classes.content}`]: {
    display: 'flex',
    alignItems: 'center',
  },
});

export default function ShareDialog(props) {
  const [isCopied, setIsCopied] = useState(false);

  const copyButtonText = isCopied ? 'Copied...' : 'Copy URL';

  return (
    <StyledDialog
      open={props.open}
      onClose={props.handleClose}
      TransitionProps={{
        onExited: () => setIsCopied(false),
      }}
    >
      <DialogTitle>Share</DialogTitle>
      <DialogContent className={classes.content}>
        <TextField variant="standard" value={props.shareURL} className={classes.textField} label="SHARE URL" disabled />
        <CopyToClipboard text={props.shareURL} onCopy={() => setIsCopied(true)}>
          <Button variant="contained" startIcon={<FontAwesomeIcon icon={faCopy} />} className={classes.buttonCopy}>
            {copyButtonText}
          </Button>
        </CopyToClipboard>
      </DialogContent>
      <DialogActions>
        <Button color="primary" onClick={props.handleClose} className={classes.buttonClose}>
          CLOSE
        </Button>
      </DialogActions>
    </StyledDialog>
  );
}

ShareDialog.propTypes = {
  handleClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  shareURL: PropTypes.string.isRequired,
};
